import '../styles/index.scss';

function initToogleTheme() {
  const body = document.querySelector('body');
  const element = document.querySelector('.ci-toggle-theme');
  if(body && element) {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      if(body.classList.contains("ci-theme--deep-gray")) {
        body.classList.remove("ci-theme--deep-gray");
      } else {
        body.classList.add("ci-theme--deep-gray");
      }
    });
  }
}

initToogleTheme();
